/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Role_AdminInputs */

const en_us2_clubs_role_admin = /** @type {(inputs: Clubs_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const pt_br2_clubs_role_admin = /** @type {(inputs: Clubs_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const es_419_clubs_role_admin = /** @type {(inputs: Clubs_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const pt_pt2_clubs_role_admin = /** @type {(inputs: Clubs_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const fr_fr2_clubs_role_admin = /** @type {(inputs: Clubs_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const de_de2_clubs_role_admin = /** @type {(inputs: Clubs_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const it_it2_clubs_role_admin = /** @type {(inputs: Clubs_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Clubs_Role_AdminInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_role_admin = /** @type {((inputs?: Clubs_Role_AdminInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Role_AdminInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_role_admin(inputs)
	if (locale === "es-419") return es_419_clubs_role_admin(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_role_admin(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_role_admin(inputs)
	if (locale === "de-DE") return de_de2_clubs_role_admin(inputs)
	if (locale === "it-IT") return it_it2_clubs_role_admin(inputs)
	return en_us2_clubs_role_admin(inputs)
});
export { clubs_role_admin as "clubs.role_admin" }